import React from 'react';
import {injectIntl} from 'react-intl';
import {NavLink} from 'react-router-dom';
import Card from 'react-bootstrap/Card';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Alert from 'react-bootstrap/Alert';

import City from '../../common/models/City';
import API from '../../common/utils/API';
import LoadingButton from '../../components/form/LoadingButton';
import ConfirmModal from '../../components/form/ConfirmModal';
import Can from '../../common/security/Can';

export class CityDetail extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            city: new City(),

            // Enable/Disable Modal
            isCityAvailabilityModalOpen: false,

            // Errors
            isLoadErrorModalOpen: false,
            error: '',

            /// Loading
            loading: false,
        };
    }

    async componentDidMount() {
        await this.fetchCity();
    }

    fetchCity = async () => {
        this.setState({loading: true});

        try {
            const {city} = await API.cities.detail(this.props.match.params.id);

            this.setState({
                city,
                loading: false,
                isLoadErrorModalOpen: false,
            });
        } catch (e) {
            this.setState({
                isLoadErrorModalOpen: true,
                loading: false,
            });
        }
    };

    toggleCityAvailabilityModal = () => {
        this.setState({
            isCityAvailabilityModalOpen: !this.state
                .isCityAvailabilityModalOpen,
        });
    };

    toggleLoadErrorModal = () => {
        this.setState({
            isLoadErrorModalOpen: !this.state.isLoadErrorModalOpen,
        });
    };

    toggleCityAvailability = async () => {
        const {city} = this.state;

        this.setState({loading: true});

        try {
            if (city.isActive) {
                await API.cities.deactivate(this.props.match.params.id);

                city.isActive = false;
            } else {
                await API.cities.activate(this.props.match.params.id);

                city.isActive = true;
            }

            this.setState({
                city,
                isCityAvailabilityModalOpen: false,
            });
        } catch (e) {
            this.setState({
                error: this.props.intl.formatMessage({
                    id: `CITIES.AVAILABILITY_TOGGLE_ERROR_MESSAGE`,
                }),
                isCityAvailabilityModalOpen: false,
            });
        }
    };

    render() {
        const {
            city: {isActive},
        } = this.state;

        return (
            <>
                <Alert
                    data-test='errorAlert'
                    variant='danger'
                    className='mb-4'
                    show={!!this.state.error}
                >
                    <p className='mb-0'>{this.state.error}</p>
                </Alert>
                <div className='mb-4 d-flex justify-content-end'>
                    <Button
                        as={NavLink}
                        to='/cities'
                        className='btn btn-dark btn-bold btn-light-dark'
                    >
                        {this.props.intl.formatMessage({
                            id: 'LIST.BACK_TO_LIST',
                        })}
                    </Button>
                </div>
                <Card className='mb-4' data-test='cityDetailComponent'>
                    <Card.Header>
                        {this.props.intl.formatMessage({
                            id: 'CITIES.GENERAL_INFORMATION_SECTION_TITLE',
                        })}
                    </Card.Header>
                    <Card.Body>
                        <Row>
                            <Col md={6}>
                                <label className='field-title'>Id</label>
                                <p>{this.state.city.id}</p>
                            </Col>
                            <Col md={6}>
                                <label className='field-title'>
                                    {this.props.intl.formatMessage({
                                        id: 'CITIES.CITY_CODE_FIELD_LABEL',
                                    })}
                                </label>
                                <p>{this.state.city.code}</p>
                            </Col>
                            <Col md={6}>
                                <label className='field-title'>
                                    {this.props.intl.formatMessage({
                                        id: 'CITIES.CITY_NAME_FIELD_LABEL',
                                    })}
                                </label>
                                <p>{this.state.city.name}</p>
                            </Col>
                            <Col md={6}>
                                <label className='field-title'>
                                    {this.props.intl.formatMessage({
                                        id: 'CITIES.CITY_STATE_LABEL',
                                    })}
                                </label>
                                <p>{this.state.city.state}</p>
                            </Col>
                            <Col md={6}>
                                <label className='field-title'>
                                    {this.props.intl.formatMessage({
                                        id: 'CITIES.CITY_COUNTRY_LABEL',
                                    })}
                                </label>
                                <p>{this.state.city.country}</p>
                            </Col>
                            <Col md={6}>
                                <label className='field-title'>
                                    {this.props.intl.formatMessage({
                                        id: 'CITIES.CITY_IS_ACTIVE_LABEL',
                                    })}
                                </label>
                                <p>
                                    {isActive
                                        ? this.props.intl.formatMessage({
                                              id: 'GENERAL.YES',
                                          })
                                        : 'No'}
                                </p>
                            </Col>
                            <Col md={6}>
                                <label className='field-title'>
                                    {this.props.intl.formatMessage({
                                        id: 'CITIES.CITY_TIMEZONE_FIELD_LABEL',
                                    })}
                                </label>
                                <p>{this.state.city.timeZone}</p>
                            </Col>
                            <Col md={6}>
                                <label className='field-title'>
                                    {this.props.intl.formatMessage({
                                        id: 'CITIES.CITY_CREATED_AT_LABEL',
                                    })}
                                </label>
                                <p>{this.state.city.createdAt}</p>
                            </Col>
                            <Col md={6}>
                                <label className='field-title'>
                                    {this.props.intl.formatMessage({
                                        id: 'CITIES.CITY_UPDATED_AT_LABEL',
                                    })}
                                </label>
                                <p>{this.state.city.updatedAt}</p>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>

                <div className='d-flex justify-content-between'>
                    <div>
                        {/*TODO: make sure that endpoints are created with this permission*/}
                        <Can run='CITIES_ACTIVATE'>
                            <ConfirmModal
                                titleModal={this.props.intl.formatMessage({
                                    id: isActive
                                        ? 'CITIES.BLOCK_CITY_MODAL'
                                        : 'CITIES.UNBLOCK_CITY_MODAL',
                                })}
                                handleConfirm={this.toggleCityAvailability}
                                handleShow={this.toggleCityAvailabilityModal}
                                handleClose={this.toggleCityAvailabilityModal}
                                show={this.state.isCityAvailabilityModalOpen}
                                variant={isActive ? 'danger' : 'success'}
                                buttonClassName={`btn-bold ${
                                    isActive
                                        ? 'btn-light-danger'
                                        : 'btn-light-success'
                                }`}
                                buttonLabel={this.props.intl.formatMessage({
                                    id: isActive
                                        ? 'CITIES.BLOCK_CITY_MODAL'
                                        : 'CITIES.UNBLOCK_CITY_MODAL',
                                })}
                                buttonAcceptLabel={this.props.intl.formatMessage(
                                    {
                                        id: isActive
                                            ? 'CITIES.CONFIRM_BLOCK_CITY'
                                            : 'CITIES.CONFIRM_UNBLOCK_CITY',
                                    },
                                )}
                                buttonCloseLabel={this.props.intl.formatMessage(
                                    {
                                        id: 'GENERAL.CANCEL',
                                    },
                                )}
                            >
                                <p>
                                    {this.props.intl.formatMessage({
                                        id: isActive
                                            ? 'CITIES.BLOCK_CITY_CONFIRMATION_MESSAGE'
                                            : 'CITIES.UNBLOCK_CITY_CONFIRMATION_MESSAGE',
                                    })}
                                </p>
                            </ConfirmModal>
                        </Can>
                    </div>
                    <div>
                        <Can run='CITIES_EDIT'>
                            <Button
                                as={NavLink}
                                to={`/cities/${this.props.match.params.id}/edit`}
                                className='btn-warning btn-bold ml-2'
                            >
                                {this.props.intl.formatMessage({
                                    id: 'CITIES.EDIT_CITY_BUTTON_TEXT',
                                })}
                            </Button>
                        </Can>
                    </div>
                </div>
                <Modal
                    show={this.state.isLoadErrorModalOpen}
                    onHide={this.toggleLoadErrorModal}
                >
                    <Modal.Header>
                        <Modal.Title>
                            {this.props.intl.formatMessage({
                                id: 'ERRORS.MODAL_TITLE',
                            })}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.props.intl.formatMessage({
                            id: 'CITIES.ERROR_MODAL_TEXT',
                        })}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            variant='secondary'
                            className='btn-bold btn-light-dark'
                            href='/cities'
                        >
                            {this.props.intl.formatMessage({
                                id: 'ERRORS.MODAL_BACK_BUTTON',
                            })}
                        </Button>
                        <LoadingButton
                            variant='primary'
                            className='btn-bold'
                            loading={this.state.loading}
                            onClick={this.fetchCity}
                        >
                            {this.props.intl.formatMessage({
                                id: 'ERRORS.MODAL_RETRY_BUTTON',
                            })}
                        </LoadingButton>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

export default injectIntl(CityDetail);
